const FULLSCREEN_OPTIONS = { navigationUI: 'hide' };

export function isFullscreenActive() {
  return !!(
    document.fullscreenElement
    || document.webkitFullscreenElement
    || document.mozFullScreenElement
    || document.msFullscreenElement
  );
}

export async function requestExamFullscreen(element = document.documentElement) {
  if (isFullscreenActive()) return true;

  const request = element.requestFullscreen
    || element.webkitRequestFullscreen
    || element.mozRequestFullScreen
    || element.msRequestFullscreen;

  if (!request) return false;

  try {
    await request.call(element, FULLSCREEN_OPTIONS);
    return isFullscreenActive();
  } catch {
    try {
      await request.call(element);
      return isFullscreenActive();
    } catch {
      return false;
    }
  }
}

export async function exitExamFullscreen() {
  if (!isFullscreenActive()) return;

  const exit = document.exitFullscreen
    || document.webkitExitFullscreen
    || document.mozCancelFullScreen
    || document.msExitFullscreen;

  if (!exit) return;

  try {
    await exit.call(document);
  } catch {
    // ignore — session ending
  }
}

const FULLSCREEN_EVENTS = [
  'fullscreenchange',
  'webkitfullscreenchange',
  'mozfullscreenchange',
  'MSFullscreenChange',
];

export function addFullscreenChangeListener(callback) {
  FULLSCREEN_EVENTS.forEach((event) => document.addEventListener(event, callback));
  return () => {
    FULLSCREEN_EVENTS.forEach((event) => document.removeEventListener(event, callback));
  };
}

/** Prefer entire-monitor share. Throws Error with code NOT_ENTIRE_SCREEN if window/tab chosen. */
export async function requestEntireScreenShare() {
  const displayStream = await navigator.mediaDevices.getDisplayMedia({
    video: {
      displaySurface: 'monitor',
      frameRate: { ideal: 10, max: 15 },
    },
    audio: false,
    preferCurrentTab: false,
    selfBrowserSurface: 'exclude',
    monitorTypeSurfaces: 'include',
    surfaceSwitching: 'exclude',
  });
  const track = displayStream.getVideoTracks()[0];
  const surface = track?.getSettings?.()?.displaySurface;
  if (surface && surface !== 'monitor') {
    displayStream.getTracks().forEach((t) => t.stop());
    const err = new Error('Please share your entire screen (not a window or tab).');
    err.code = 'NOT_ENTIRE_SCREEN';
    throw err;
  }
  return displayStream;
}
